import { FC,useState } from "react"
import { addDays, format } from "date-fns";

import Modal from "../modal";
import CustomCardComponent from "../customCardComponent";

import { StatisticsObjectType } from "./types";



const CustomButtonRight: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");

  const openModal = (title: string) => {
    setTitle(title);
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  return (
      <>
        <div className="row g-2">
          <CustomCardComponent title={`Territories With Orders ${format(addDays(new Date(), -1), "MM/dd/yyyy")}`} value={StatisticsObjectType.territories_with_order}/>
          <CustomCardComponent title="Median Days per Order" value={StatisticsObjectType.median_per_day} />
          <CustomCardComponent title="Avg Days per Order" value={StatisticsObjectType.average_day_per_order} />
          <CustomCardComponent title="Unique Prescribers" value={StatisticsObjectType.uniq_prescribers} />
          <CustomCardComponent title="Unique Patients" value={StatisticsObjectType.uniq_patients} />
          <CustomCardComponent title="Avg Qty per Order" value={Number(StatisticsObjectType.avg_qty_per_order).toFixed(1)} />
          <CustomCardComponent title="Total Orders" value={StatisticsObjectType.total_orders} />
        </div>
        <div className="row mt-3 gx-2" style={{maxHeight: 550}}>

          {showingModal ? <Modal title={title}
                                 data={title === "New Practices" ? StatisticsObjectType.new_practices.data : StatisticsObjectType.new_prescriber.data}
                                 onClick={() => setModal(false)}></Modal> : null}

          <div className="col-12 col-lg-6 mb-3">
            <div className="card" style={{height: 150}}>
              <div className="card-header text-center">
                <h1 className="mt-2 mb-0">New Practices</h1>
              </div>
              <div className="card-body  text-center" onClick={() => {
                openModal("New Practices")
              }}>
                <h1 className="btn-link text-center fw-bold">{StatisticsObjectType.new_practices.count}</h1>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-6 mb-3">
            <div className="card" style={{height: 150}}>
              <div className="card-header text-center">
                <h1 className="mt-2 mb-0">New Prescribers</h1>
              </div>
              <div className="card-body text-center" onClick={() => {
                openModal("New Prescribers")
              }}>
                <h1 className="btn-link text-center fw-bold">{StatisticsObjectType.new_prescriber.count}</h1>
              </div>
            </div>
          </div>
        </div>
      </>
  )
}
export default CustomButtonRight;
